const getUlohySort = (sortValue): string => {
  const secondarySort = 'datumPrijatia';
  switch (sortValue) {
    case 'cisloLp':
      return sortValue;
    case 'nazov':
      return `${sortValue},${secondarySort}`;
    case 'datumPrijatia':
      return sortValue;
    case 'stadium':
      return `${sortValue},${secondarySort}`;
    default:
      return `datumVybavenia,${secondarySort}`;
  }
};
export default getUlohySort;
